import { ListingDisplayV2 } from 'src/components/Listings/ListingDisplay/ListingDisplayV2';
import { Stack } from 'src/core/ui';
import { Listing } from 'src/WebApiController';

export const SeatingDisplay = ({
  listing,
  title,
  showOrgSeat,
}: {
  listing: Listing;
  title?: string;
  showOrgSeat: boolean;
}) => (
  <Stack title={title} direction="column" gap="s" width="full">
    <ListingDisplayV2
      listing={listing}
      showOrgSeat={showOrgSeat}
      width="full"
      justifySeatingIconContent="spaceBetween"
      allowDisplaySeatingOverride={true}
    />
  </Stack>
);
